<div class="editor-display-container" *ngIf="visible">
  <div [outerHTML]="text"></div>
</div>